import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { requestDeleteDeliveryCompany } from "./deleteDeliveryCompany.request";

const useDeleteDeliveryCompany = (
  options?: MutationOptions<void, ApiServiceError<ApiError>>
) => {
  return useMutation({
    mutationFn: requestDeleteDeliveryCompany,
    ...options
  });
};

export default useDeleteDeliveryCompany;
